/* eslint-disable no-console */
import { useState, useEffect } from "react";

const settings = {
	enableHighAccuracy: false,
	timeout: Infinity,
	maximumAge: 0
};

export const usePosition = () => {
	const [position, setPosition] = useState({
		latitude: 43.8413273384353,
		longitude: -79.422204502351
	});

	const onChange = ({ coords }: GeolocationPosition) => {
		setPosition({
			latitude: coords.latitude,
			longitude: coords.longitude
		});
	};

	const onError = () => {
		console.error("Geolocation is not supported");
	};

	useEffect(() => {
		if (!navigator || !navigator.geolocation) {
			console.error("Geolocation is not supported");
			return;
		}

		navigator.geolocation.getCurrentPosition(onChange, onError, settings);
	}, [settings.enableHighAccuracy, settings.timeout, settings.maximumAge]);

	return { ...position };
};
